import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres85u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres85u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres85u/index', { params: sendParams })
  },
  getDetail (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres85u/detail/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres85u/dropdowns')
  },
  getDetailSubmit (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_approvno: detailParams.approvno,
      p_staappr: detailParams.staappr
    }
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno + '/' + searchParams.p_staappr
    if (isMock) return generator(mocker.detailSubmit())
    return instance().get(endpoint + '/hres85u/detailSubmit/' + params)
  },
  postSendApprove (approveParams) {
    let dteappr
    let dtepay
    if (typeof approveParams.dteappr !== 'undefined') {
      dteappr = approveParams.dteappr.replace(/\//g, '')
    }
    if (typeof approveParams.dtepay !== 'undefined') {
      dtepay = approveParams.dtepay.replace(/\//g, '')
    }
    let paramJson = {
      '0': {
        p_staappr: approveParams.flgStaappr,
        p_approvno: approveParams.approvno,
        p_chk_appr: approveParams.chk_appr,
        p_codempid: approveParams.codempid,
        p_numseq: approveParams.numseq,
        p_dtereq: approveParams.dtereq,
        p_codappr: approveParams.codappr,
        p_dteappr: dteappr,
        p_amtappr: approveParams.amtappr,
        p_typepay: approveParams.typepay,
        p_dtepay: dtepay,
        p_numperiod: approveParams.numperiod,
        p_dtemthpay: approveParams.dtemthpay,
        p_dteyrepay: approveParams.dteyrepay,
        p_codpay: approveParams.codpay,
        p_status: approveParams.status,
        p_remark: approveParams.remark,
        p_flgwarn: ''
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson),
      remarkApprove: (approveParams.staappr === 'A') ? approveParams.remark : '',
      remarkReject: (approveParams.staappr === 'N') ? approveParams.remark : ''
    }
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres85u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres85u/index.js